import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../forms/FormMixin'
import useGlobal from '../../composables/useGlobal'
import executeWithRefresh from '@/composables/useRefresher'
import { createSubscription } from '@/services/order.service'
import { sendConfirmEmail } from '@/analytics/ConfirmEmail'
import {
  getCookie,
  setCookie,
} from '@/utils/cookies'

import {
  HQ_USER_SAVED_NAME,
  HQ_REFERENCE_COOKIE_NAME,
} from '@/const'


export default /*#__PURE__*/_defineComponent({
  __name: 'StepTwo',
  props: ['sub'],
  emits: ['nextStep'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props



const { $t } = useGlobal()
const nextStep = ref({
  step: 3,
})
const load = ref(false)
const placeholder = ref("Введите ваш e-mail")
const isLoad: Ref<boolean> = ref(false)
const mailSended = ref(false)
const mailError = ref(false)
const email = ref(getCookie(HQ_USER_SAVED_NAME)?.replaceAll('"', '') || '')
const code = ref("")

const request = (sendData: any, control: any) => {
  useSubmit(send(sendData), control)
}

function setNextStep(id, orderId) {
  if (id) nextStep.value.id = id
  if (orderId) nextStep.value.orderId = orderId
  emit('next', nextStep)
}

const formatter = str => {
  return String(str).length > 1 ? str : `0${str}`
}

const send = async sendData => {
  const prepearedData = {
    ...sendData,
    subscription: props.sub.id,
    ref_id: getCookie(HQ_REFERENCE_COOKIE_NAME),
  }
  try {
    load.value = true
    const res = (await executeWithRefresh(createSubscription, null, {}, prepearedData))
    setCookie(HQ_USER_SAVED_NAME, email.value)
    load.value = false
    setNextStep(false, res.data.id)
    sendConfirmEmail(email.value, props.sub.label)
  } catch(e) {
    load.value = false
    isLoad.value = false
    return Promise.reject(e)
  }
}

  
const __returned__ = { props, emit, $t, nextStep, load, placeholder, isLoad, mailSended, mailError, email, code, request, setNextStep, formatter, send, ref, useSubmit, useGlobal, executeWithRefresh, createSubscription, sendConfirmEmail, getCookie, setCookie, HQ_USER_SAVED_NAME, HQ_REFERENCE_COOKIE_NAME }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})